import { getStorage, setStorage } from 'js/storage';

export default class ContentDialog {
    DEFAULT_CONFIG = {
        storageName: 'viaBovag_content-dialog',
        errorMessageAttribute: 'data-js-content-dialog-error-message',
        baseClassName: 'content-dialog',
        storageSelector: 'content-dialog'
    };

    constructor() {
        this.config = { ...this.config, ...this.DEFAULT_CONFIG };
    }

    init() {
        this.bindListeners();
    }

    bindListeners() {
        this.closeButton.addEventListener('click', () => {
            this.saveContentDialogHideSetting();
            this.removeContentDialog();
        });
        if (this.image) {
            this.image.addEventListener('load', () => {
                this.node.classList.add(`${this.config.baseClassName}--active`);
            });
        } else {
            this.node.classList.add(`${this.config.baseClassName}--active`);
        }
    }

    saveContentDialogHideSetting() {
        this.contentDialogStorage.push(this.contentDialogId);
        setStorage(this.config.storageSelector, this.contentDialogStorage);
    }

    /**
     * @param {string} id
     * @param {string} [imageSrc]
     * @param {string} text
     * @param {string} title
     * @param {string} [buttonText]
     * @param {string} [buttonHref]
     * @param {string} [buttonTarget]
     * @param {object} [form]
     */
    showContentDialog({ id, imageSrc, text, title, buttonText, buttonHref, buttonTarget = '_blank', form }) {
        /** @type {string[]} */
        this.contentDialogStorage = getStorage(this.config.storageSelector) || [];
        this.contentDialogId = id;
        if (!id || !text) {
            return;
        }
        if (this.contentDialogStorage.includes(this.contentDialogId)) {
            return;
        }

        const existingNode = document.querySelector(`.${this.config.baseClassName}`);
        if (existingNode) {
            existingNode.remove();
        }
        this.createHTML({ imageSrc, text, title, buttonText, buttonHref, buttonTarget, form });

        if (form) {
            this.inputHandler = this.formInput.addEventListener('input', () => {
                if (this.errorMessage) {
                    this.errorMessage.remove();
                    this.errorMessage = null;
                }
            });
            this.buttonHandler = this.button.addEventListener('click', e => {
                e.preventDefault();
                const result = form.callBack(this.formInput.value);
                if (result) {
                    this.formField.innerText = form.success;
                    this.button.remove();
                } else if (this.errorMessage) {
                    this.errorMessage.innerText = form.error;
                } else {
                    this.errorMessage = document.createElement('p');
                    this.errorMessage.innerText = form.error;
                    this.formField.append(this.errorMessage);
                }
            });
        }
        this.init();
    }

    createHTML(params) {
        this.node = document.createElement('div');
        this.node.className = `${this.config.baseClassName}__backdrop`;

        const backdrop = document.createElement('div');
        backdrop.className = this.config.baseClassName;

        const wrapper = document.createElement('div');
        wrapper.className = `${this.config.baseClassName}__wrapper`;

        if (params.imageSrc) {
            this.image = document.createElement('img');
            this.image.className = `${this.config.baseClassName}__image`;
            this.image.src = params.imageSrc;
            this.image.alt = '';
        } else {
            this.image = '';
        }

        const title = document.createElement('h2');
        title.className = `${this.config.baseClassName}__title`;
        title.innerHTML = params.title;

        const paragraph = document.createElement('p');
        paragraph.className = `${this.config.baseClassName}__text`;
        paragraph.innerHTML = params.text;

        this.button = '';
        if ((params.buttonHref && params.buttonText) || params.form) {
            this.button = document.createElement('a');
            this.button.href = params.buttonHref;
            this.button.innerHTML = params.buttonText;
            this.button.target = params.buttonTarget;
            this.button.className = `button button-primary ${this.config.baseClassName}__button`;
        }

        this.formField = params.form ? this.generateForm(params.form) : '';

        /** @type {Node} */
        this.closeButton = document.createElement('button');
        this.closeButton.className = `${this.config.baseClassName}__close`;
        this.closeButton.innerHTML = '✖';

        wrapper.append(this.image, title, paragraph, this.formField, this.button, this.closeButton);
        backdrop.append(wrapper);

        this.node.append(backdrop);
        document.body.append(this.node);
    }

    generateForm(form) {
        const formField = document.createElement('div');
        formField.className = `${this.config.baseClassName}__form`;

        const formTitle = document.createElement('p');
        formTitle.className = `${this.config.baseClassName}__form-title`;
        formTitle.innerText = form.instruction;

        const formLabel = document.createElement('label');
        formLabel.className = 'form-field';

        this.formInput = document.createElement('input');
        this.formInput.className = 'form-field__input';
        this.formInput.placeholder = form.placeholder;

        const span = document.createElement('span');
        span.className = 'form-field__replacement';

        formLabel.append(this.formInput, span);

        formField.append(formTitle, formLabel);
        return formField;
    }

    /**
     * Removes the dialog
     */
    removeContentDialog() {
        this.node.classList.remove(`${this.config.baseClassName}--active`);
        setTimeout(() => {
            this.node.remove();
        }, 500);
    }
}
